import { createContext, useContext, useState, useEffect } from 'react';
import T from '../i18n/translations';

const LanguageContext = createContext({ lang: 'EN', setLang: () => {}, t: () => '' });

export function LanguageProvider({ children }) {
  // Initialize from localStorage or default to 'EN'
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem('vvs-lang');
    return saved && T[saved] ? saved : 'EN';
  });

  // Persist language selection to localStorage
  const setLang = (newLang) => {
    if (T[newLang]) {
      setLangState(newLang);
      localStorage.setItem('vvs-lang', newLang);
    }
  };

  const t = (path) => {
    const keys = path.split('.');
    let val = T[lang];
    for (const key of keys) {
      if (val == null) return path;
      val = val[key];
    }
    return val !== undefined ? val : path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
